import React from "react";
import { motion } from "framer-motion";

interface SlideBottomProps {
  title: string;
  details: string;
  variant?: "blue" | "green";
}

const SlideBottom: React.FC<SlideBottomProps> = ({
  variant = "blue",
  title,
  details,
}) => {
  const bgImage =
    variant === "green"
      ? "bg-[url('/images/ServicesInner/slider-green.png')]"
      : "bg-[url('/images/ServicesInner/slider-blue.png')]";

  return (
    <div
      className={`xl:px-6 px-4 xl:py-8 py-5 text-white ${bgImage} bg-no-repeat bg-contain bg-top-right`}
    >
      <div className="xl:pb-[76px] md:pb-[50px]">
        <motion.h5
          className="xl:text-heading-5 text-heading-6 font-bold text-primary-text-white"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {title}
        </motion.h5>
        <motion.p
          className="xl:text-subtitle-1 text-subtitle-3 font-regular text-secondary-text-white lg:mt-6 mt-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {details}
        </motion.p>
      </div>
    </div>
  );
};

export default SlideBottom;
